// ─── Login ────────────────────────────────────────────────────────────────────
export const login = async (email, password) => {
  const response = await fetch('/api/Auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Giriş başarısız.');
  }
  return response.json();
};

// ─── Şifremi unuttum ──────────────────────────────────────────────────────────
export const forgotPassword = async (email) => {
  const response = await fetch('/api/Auth/forgot-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) throw new Error('İstek başarısız.');
  return response.json();
};

// ─── İlk kez giriş — aktivasyon linki talep et ───────────────────────────────
export const activateAccount = async (email) => {
  const response = await fetch('/api/Auth/activate-account', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) throw new Error('İstek başarısız.');
  return response.json();
};

// ─── Şifre sıfırla (token ile) ───────────────────────────────────────────────
export const resetPassword = async (token, newPassword) => {
  const response = await fetch('/api/Auth/reset-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Şifre sıfırlama başarısız.');
  }
  return response.json();
};

// ─── Şifre değiştir (giriş yapmış kullanıcı) ─────────────────────────────────
export const changePassword = async (currentPassword, newPassword, authToken) => {
  const response = await fetch('/api/Auth/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Şifre değiştirme başarısız.');
  }
  return response.json();
};

// ─── Token yenile ─────────────────────────────────────────────────────────────
export const refreshToken = async (token) => {
  const response = await fetch('/api/Auth/refresh-token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  if (!response.ok) throw new Error('Token yenileme başarısız.');
  return response.json();
};